module.exports = __webpack_public_path__ + "static/media/color_logo_transparent_white.7091c9fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/color_logo_transparent_white.svg
// module id = 509
// module chunks = 37